"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BracketsViewer = void 0;
require("./style.scss");
const brackets_model_1 = require("brackets-model");
const helpers_1 = require("./helpers");
const dom = __importStar(require("./dom"));
const lang = __importStar(require("./lang"));
const brackets_manager_1 = require("brackets-manager");
class BracketsViewer {
    constructor() {
        this.participantRefs = {};
        this.participants = [];
        this.participantImages = [];
        this.skipFirstRound = false;
        this.alwaysConnectFirstRound = false;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this._onMatchClick = (match) => { };
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this._onMatchLabelClick = (match) => { };
    }
    // eslint-disable-next-line jsdoc/require-jsdoc
    getRoundName(info, fallbackGetter) {
        var _a, _b;
        return ((_b = (_a = this.config).customRoundName) === null || _b === void 0 ? void 0 : _b.call(_a, info, lang.t)) || fallbackGetter(info, lang.t);
    }
    /**
     * @deprecated Use `onMatchClick` in the `config` parameter of `viewer.render()`.
     * @param callback A callback to be called when a match is clicked.
     */
    set onMatchClicked(callback) {
        this._onMatchClick = callback;
    }
    /**
     * Renders data generated with `brackets-manager.js`. If multiple stages are given, they will all be displayed.
     *
     * Stages won't be discriminated visually based on the tournament they belong to.
     *
     * @param data The data to display.
     * @param config An optional configuration for the viewer.
     */
    // eslint-disable-next-line @typescript-eslint/require-await -- Keep this async for backwards compatibility.
    async render(data, config) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        if (typeof data === 'string')
            throw Error('Using a CSS selector as the first argument is deprecated. Please look here: https://github.com/Drarig29/brackets-viewer.js');
        const root = document.createDocumentFragment();
        this.config = {
            customMatchLabel: config === null || config === void 0 ? void 0 : config.customMatchLabel,
            customFinalMatchLabel: config === null || config === void 0 ? void 0 : config.customFinalMatchLabel,
            customRoundName: config === null || config === void 0 ? void 0 : config.customRoundName,
            participantOriginPlacement: (_a = config === null || config === void 0 ? void 0 : config.participantOriginPlacement) !== null && _a !== void 0 ? _a : 'before',
            separatedChildCountLabel: (_b = config === null || config === void 0 ? void 0 : config.separatedChildCountLabel) !== null && _b !== void 0 ? _b : false,
            showSlotsOrigin: (_c = config === null || config === void 0 ? void 0 : config.showSlotsOrigin) !== null && _c !== void 0 ? _c : true,
            showLowerBracketSlotsOrigin: (_d = config === null || config === void 0 ? void 0 : config.showLowerBracketSlotsOrigin) !== null && _d !== void 0 ? _d : true,
            showPopoverOnMatchLabelClick: (_e = config === null || config === void 0 ? void 0 : config.showPopoverOnMatchLabelClick) !== null && _e !== void 0 ? _e : true,
            highlightParticipantOnHover: (_f = config === null || config === void 0 ? void 0 : config.highlightParticipantOnHover) !== null && _f !== void 0 ? _f : true,
            highlightPlaceholdersOnHover: (_g = config === null || config === void 0 ? void 0 : config.highlightPlaceholdersOnHover) !== null && _g !== void 0 ? _g : false,
            showRankingTable: (_h = config === null || config === void 0 ? void 0 : config.showRankingTable) !== null && _h !== void 0 ? _h : true,
            getStyleForMatch: config === null || config === void 0 ? void 0 : config.getStyleForMatch,
            noParticipantTitles: config === null || config === void 0 ? void 0 : config.noParticipantTitles,
        };
        if (config === null || config === void 0 ? void 0 : config.onMatchClick)
            this._onMatchClick = config.onMatchClick;
        if (config === null || config === void 0 ? void 0 : config.onMatchLabelClick)
            this._onMatchLabelClick = config.onMatchLabelClick;
        if (!((_j = data.stages) === null || _j === void 0 ? void 0 : _j.length))
            throw Error('The `data.stages` array is either empty or undefined');
        if (!((_k = data.participants) === null || _k === void 0 ? void 0 : _k.length))
            throw Error('The `data.participants` array is either empty or undefined');
        if (!((_l = data.matches) === null || _l === void 0 ? void 0 : _l.length))
            throw Error('The `data.matches` array is either empty or undefined');
        this.participants = data.participants;
        data.participants.forEach(participant => this.participantRefs[participant.id] = []);
        this.popover = document.createElement('div');
        this.popover.setAttribute('popover', 'auto');
        this.popover.addEventListener('toggle', (event) => {
            if (event.newState === 'closed')
                this.clearPreviousPopoverSelections();
        });
        root.append(this.popover);
        data.stages.forEach(stage => this.renderStage(root, {
            ...data,
            stages: [stage],
            matches: data.matches
                .filter(match => match.stage_id === stage.id)
                .map(match => ({
                ...match,
                metadata: {
                    stageType: stage.type,
                    games: data.matchGames.filter(game => game.parent_id === match.id),
                },
            })),
        }));
        const target = (0, helpers_1.findRoot)(config === null || config === void 0 ? void 0 : config.selector);
        if (config === null || config === void 0 ? void 0 : config.clear)
            target.innerHTML = '';
        target.append(root);
    }
    /**
     * Updates the results of an existing match.
     *
     * @param match The match to update.
     */
    updateMatch(match) {
        //  TODO: finish this function (update win/loss/forfeit, scoreboard in round-robin, etc.)
        var _a, _b, _c, _d, _e, _f;
        const matchContainer = document.querySelector(`[data-match-id='${match.id}']`);
        if (!matchContainer)
            throw Error('Match not found.');
        matchContainer.setAttribute('data-match-status', match.status.toString());
        const result1 = matchContainer.querySelector('.participant:nth-of-type(1) .result');
        if (result1 && ((_a = match.opponent1) === null || _a === void 0 ? void 0 : _a.score))
            result1.innerHTML = (_c = (_b = match.opponent1) === null || _b === void 0 ? void 0 : _b.score) === null || _c === void 0 ? void 0 : _c.toString();
        const result2 = matchContainer.querySelector('.participant:nth-of-type(2) .result');
        if (result2 && ((_d = match.opponent2) === null || _d === void 0 ? void 0 : _d.score))
            result2.innerHTML = (_f = (_e = match.opponent2) === null || _e === void 0 ? void 0 : _e.score) === null || _f === void 0 ? void 0 : _f.toString();
    }
    /**
     * Sets the images which will be rendered for every participant.
     *
     * @param images The participant images.
     */
    setParticipantImages(images) {
        this.participantImages = images;
    }
    /**
     * Adds a locale to the available i18n bundles.
     *
     * @param name Name of the locale.
     * @param locale Contents of the locale.
     */
    async addLocale(name, locale) {
        await lang.addLocale(name, locale);
    }
    /**
     * Renders a stage (round-robin, single or double elimination).
     *
     * @param root The root element.
     * @param data The data to display.
     */
    renderStage(root, data) {
        var _a;
        const stage = data.stages[0];
        if (!((_a = data.matches) === null || _a === void 0 ? void 0 : _a.length))
            throw Error(`No matches found for stage ${stage.id}`);
        // Consolation matches are under `-1` in the array.
        const matchesByGroup = (0, helpers_1.splitByWithLeftovers)(data.matches, 'group_id');
        this.stage = stage;
        this.skipFirstRound = stage.settings.skipFirstRound || false;
        switch (stage.type) {
            case 'round_robin':
                this.renderRoundRobin(root, stage, matchesByGroup);
                break;
            case 'single_elimination':
            case 'double_elimination':
                this.renderElimination(root, stage, matchesByGroup);
                break;
            default:
                throw Error(`Unknown bracket type: ${stage.type}`);
        }
        this.renderConsolationMatches(root, stage, matchesByGroup);
    }
    /**
     * Renders a round-robin stage.
     *
     * @param root The root element.
     * @param stage The stage to render.
     * @param matchesByGroup A list of matches for each group.
     */
    renderRoundRobin(root, stage, matchesByGroup) {
        const container = dom.createRoundRobinContainer(stage.id);
        container.append(dom.createTitle(stage.name));
        let groupNumber = 1;
        for (const groupMatches of matchesByGroup) {
            const groupId = groupMatches[0].group_id;
            const groupContainer = dom.createGroupContainer(groupId, lang.getGroupName(groupNumber++));
            const matchesByRound = (0, helpers_1.splitBy)(groupMatches, 'round_id').map(matches => (0, helpers_1.sortBy)(matches, 'number'));
            let roundNumber = 1;
            for (const roundMatches of matchesByRound) {
                const roundId = roundMatches[0].round_id;
                const roundName = this.getRoundName({
                    roundNumber,
                    roundCount: 0,
                    groupType: lang.toI18nKey('round_robin'),
                }, lang.getRoundName);
                const roundContainer = dom.createRoundContainer(roundId, roundName);
                for (const match of roundMatches)
                    roundContainer.append(this.createMatch(match, true));
                groupContainer.append(roundContainer);
                roundNumber++;
            }
            if (this.config.showRankingTable)
                groupContainer.append(this.createRanking(groupMatches));
            container.append(groupContainer);
        }
        root.append(container);
    }
    /**
     * Renders an elimination stage (single or double).
     *
     * @param root The root element.
     * @param stage The stage to render.
     * @param matchesByGroup A list of matches for each group.
     */
    renderElimination(root, stage, matchesByGroup) {
        const container = dom.createEliminationContainer(stage.id);
        container.append(dom.createTitle(stage.name));
        if (stage.type === 'single_elimination')
            this.renderSingleElimination(container, matchesByGroup);
        else
            this.renderDoubleElimination(container, matchesByGroup);
        root.append(container);
    }
    /**
     * Renders a list of consolation matches.
     *
     * @param root The root element.
     * @param stage The stage to render.
     * @param matchesByGroup A list of matches for each group.
     */
    renderConsolationMatches(root, stage, matchesByGroup) {
        const consolationMatches = matchesByGroup[-1];
        if (!(consolationMatches === null || consolationMatches === void 0 ? void 0 : consolationMatches.length))
            return;
        const consolation = dom.createBracketContainer(undefined, lang.t('common.consolation'));
        const roundsContainer = dom.createRoundsContainer();
        let matchNumber = 0;
        for (const match of consolationMatches) {
            roundsContainer.append(this.createMatch({
                ...match,
                metadata: {
                    label: lang.t('match-label.default', { matchNumber: ++matchNumber }),
                    stageType: stage.type,
                    games: [],
                },
            }, true));
        }
        consolation.append(roundsContainer);
        root.append(consolation);
    }
    /**
     * Renders a single elimination stage.
     *
     * @param container The container to render into.
     * @param matchesByGroup A list of matches for each group.
     */
    renderSingleElimination(container, matchesByGroup) {
        const bracketMatches = (0, helpers_1.splitBy)(matchesByGroup[0], 'round_id').map(matches => (0, helpers_1.sortBy)(matches, 'number'));
        const { hasFinal, connectFinal, finalMatches } = this.getFinalInfoSingleElimination(matchesByGroup);
        this.renderBracket(container, bracketMatches, lang.getRoundName, 'single_bracket', connectFinal);
        if (hasFinal)
            this.renderFinal(container, 'consolation_final', finalMatches);
    }
    /**
     * Renders a double elimination stage.
     *
     * @param container The container to render into.
     * @param matchesByGroup A list of matches for each group.
     */
    renderDoubleElimination(container, matchesByGroup) {
        const hasLoserBracket = matchesByGroup[1] !== undefined;
        const winnerBracketMatches = (0, helpers_1.splitBy)(matchesByGroup[0], 'round_id').map(matches => (0, helpers_1.sortBy)(matches, 'number'));
        const { hasFinal, connectFinal, grandFinalMatches, consolationFinalMatches } = this.getFinalInfoDoubleElimination(matchesByGroup);
        this.renderBracket(container, winnerBracketMatches, lang.getWinnerBracketRoundName, 'winner_bracket', connectFinal);
        if (hasLoserBracket) {
            const loserBracketMatches = (0, helpers_1.splitBy)(matchesByGroup[1], 'round_id').map(matches => (0, helpers_1.sortBy)(matches, 'number'));
            this.renderBracket(container, loserBracketMatches, lang.getLoserBracketRoundName, 'loser_bracket');
        }
        if (hasFinal) {
            this.renderFinal(container, 'grand_final', grandFinalMatches);
            this.renderFinal(container, 'consolation_final', consolationFinalMatches);
        }
    }
    /**
     * Returns information about the final group in single elimination.
     *
     * @param matchesByGroup A list of matches for each group.
     */
    getFinalInfoSingleElimination(matchesByGroup) {
        var _a;
        const hasFinal = matchesByGroup[1] !== undefined;
        const finalMatches = (0, helpers_1.sortBy)((_a = matchesByGroup[1]) !== null && _a !== void 0 ? _a : [], 'number');
        // In single elimination, the only possible type of final is a consolation final,
        // and it has to be disconnected from the bracket because it doesn't directly follows its last match.
        const connectFinal = false;
        return { hasFinal, connectFinal, finalMatches };
    }
    /**
     * Returns information about the final group in double elimination.
     *
     * @param matchesByGroup A list of matches for each group.
     */
    getFinalInfoDoubleElimination(matchesByGroup) {
        var _a;
        const hasFinal = matchesByGroup[2] !== undefined;
        const finalMatches = (0, helpers_1.sortBy)((_a = matchesByGroup[2]) !== null && _a !== void 0 ? _a : [], 'number');
        // All grand final matches have a `number: 1` property. We can have 0, 1 or 2 of them.
        const grandFinalMatches = finalMatches.filter(match => match.number === 1);
        // All consolation matches have a `number: 2` property (set by the manager). We can only have 0 or 1 of them.
        const consolationFinalMatches = finalMatches.filter(match => match.number === 2);
        // In double elimination, we can have a grand final, a consolation final, or both.
        // We only want to connect the upper bracket with the final group when we have at least one grand final match.
        // The grand final will always be placed directly next to the bracket.
        const connectFinal = grandFinalMatches.length > 0;
        return { hasFinal, connectFinal, grandFinalMatches, consolationFinalMatches };
    }
    /**
     * Renders a bracket.
     *
     * @param container The container to render into.
     * @param matchesByRound A list of matches for each round.
     * @param getRoundName A function giving a round's name based on its number.
     * @param bracketType Type of the bracket.
     * @param connectFinal Whether to connect the last match of the bracket to the first match of the final group.
     */
    renderBracket(container, matchesByRound, getRoundName, bracketType, connectFinal) {
        const groupId = matchesByRound[0][0].group_id;
        const roundCount = matchesByRound.length;
        const bracketContainer = dom.createBracketContainer(groupId, lang.getBracketName(this.stage, bracketType), roundCount);
        const roundsContainer = dom.createRoundsContainer();
        const { matches: completedMatches, fromToornament } = (0, helpers_1.completeWithBlankMatches)(bracketType, matchesByRound[0], matchesByRound[1]);
        this.alwaysConnectFirstRound = !fromToornament;
        for (let roundIndex = 0; roundIndex < matchesByRound.length; roundIndex++) {
            const roundId = matchesByRound[roundIndex][0].round_id;
            const roundNumber = roundIndex + 1;
            const roundName = this.getRoundName({
                roundNumber,
                roundCount,
                fractionOfFinal: brackets_manager_1.helpers.getFractionOfFinal(roundNumber, roundCount),
                groupType: lang.toI18nKey(bracketType),
            }, getRoundName);
            const roundContainer = dom.createRoundContainer(roundId, roundName);
            const roundMatches = fromToornament && roundNumber === 1 ? completedMatches : matchesByRound[roundIndex];
            for (const match of roundMatches) {
                roundContainer.append(match && this.createBracketMatch({
                    ...match,
                    metadata: {
                        ...match.metadata,
                        roundNumber,
                        roundCount,
                        matchLocation: bracketType,
                        connectFinal,
                    },
                }) || this.skipBracketMatch());
            }
            roundsContainer.append(roundContainer);
        }
        bracketContainer.append(roundsContainer);
        container.append(bracketContainer);
    }
    /**
     * Renders a final group.
     *
     * @param container The container to render into.
     * @param finalType Type of the final.
     * @param matches Matches of the final.
     */
    renderFinal(container, finalType, matches) {
        // Double elimination stages can have a grand final, or a consolation final, or both.
        if (matches.length === 0)
            return;
        const upperBracket = container.querySelector('.bracket .rounds');
        if (!upperBracket)
            throw Error('Upper bracket not found.');
        const winnerWb = matches[0].opponent1;
        const displayCount = (winnerWb === null || winnerWb === void 0 ? void 0 : winnerWb.id) === null || (winnerWb === null || winnerWb === void 0 ? void 0 : winnerWb.result) === 'win' ? 1 : 2;
        const finalMatches = matches.slice(0, displayCount);
        const roundCount = finalMatches.length;
        const defaultFinalRoundNameGetter = ({ roundNumber }) => this.getFinalMatchLabel(finalType, finalMatches[roundNumber - 1]);
        for (let roundIndex = 0; roundIndex < finalMatches.length; roundIndex++) {
            const roundNumber = roundIndex + 1;
            const roundName = this.getRoundName({
                roundNumber,
                roundCount,
                groupType: lang.toI18nKey('final_group'),
                finalType: lang.toI18nKey(finalType),
            }, defaultFinalRoundNameGetter);
            const finalMatch = {
                ...finalMatches[roundIndex],
                metadata: {
                    ...finalMatches[roundIndex].metadata,
                    roundNumber,
                    roundCount,
                    matchLocation: 'final_group',
                },
            };
            const roundContainer = dom.createRoundContainer(finalMatch.round_id, roundName);
            roundContainer.append(this.createFinalMatch(finalType, finalMatch));
            upperBracket.append(roundContainer);
        }
    }
    /**
     * Creates a ranking table based on matches of a round-robin stage.
     *
     * @param matches The list of matches.
     */
    createRanking(matches) {
        const table = dom.createTable();
        const ranking = (0, helpers_1.getRanking)(matches);
        table.append(dom.createRankingHeaders(ranking));
        for (const item of ranking)
            table.append(this.createRankingRow(item));
        return table;
    }
    /**
     * Creates a row of the ranking table.
     *
     * @param item Item of the ranking.
     */
    createRankingRow(item) {
        const row = dom.createRow();
        const notRanked = item.played === 0;
        for (const key in item) {
            const prop = key;
            const data = item[prop];
            if (prop === 'id') {
                const participant = this.participants.find(participant => participant.id === data);
                if (participant !== undefined) {
                    const cell = dom.createCell(participant.name);
                    this.setupMouseHover(participant.id, cell, true);
                    row.append(cell);
                    continue;
                }
            }
            if (notRanked && (prop === 'rank' || prop === 'points')) {
                row.append(dom.createCell('-'));
                continue;
            }
            row.append(dom.createCell(data));
        }
        return row;
    }
    /**
     * Creates a match in a bracket.
     *
     * @param match Information about the match.
     */
    createBracketMatch(match) {
        const { roundNumber, roundCount, matchLocation, connectFinal } = match.metadata;
        if (roundNumber === undefined || roundCount === undefined || matchLocation === undefined)
            throw Error(`The match's internal data is missing roundNumber, roundCount or matchLocation: ${JSON.stringify(match)}`);
        const connection = dom.getBracketConnection(this.alwaysConnectFirstRound, roundNumber, roundCount, match, matchLocation, connectFinal);
        const matchLabel = this.getMatchLabel(match);
        const originHint = lang.getOriginHint(roundNumber, roundCount, this.skipFirstRound, matchLocation);
        match.metadata.connection = connection;
        match.metadata.label = matchLabel;
        match.metadata.originHint = originHint;
        return this.createMatch(match, true);
    }
    /**
     * Creates a match in a final.
     *
     * @param finalType Type of the final.
     * @param match Information about the match.
     */
    createFinalMatch(finalType, match) {
        const { roundNumber, roundCount } = match.metadata;
        if (roundNumber === undefined || roundCount === undefined)
            throw Error(`The match's internal data is missing roundNumber or roundCount: ${JSON.stringify(match)}`);
        const connection = dom.getFinalConnection(finalType, roundNumber, roundCount);
        const matchLabel = this.getFinalMatchLabel(finalType, match);
        const originHint = lang.getFinalOriginHint(match.metadata.stageType, finalType, roundNumber);
        match.metadata.connection = connection;
        match.metadata.label = matchLabel;
        match.metadata.originHint = originHint;
        return this.createMatch(match, true);
    }
    /**
     * Gets the label for the match, starting from our i18n database and
     * calling `this.config.customMatchLabel`, if that has been set.
     *
     * @param match Information about the match.
     */
    getMatchLabel(match) {
        const { roundNumber, roundCount, matchLocation } = match.metadata;
        const matchLabel = lang.getMatchLabel(match.number, roundNumber, roundCount, matchLocation);
        const customMatchLabel = this.config.customMatchLabel;
        return customMatchLabel ? customMatchLabel(match, lang.t, matchLabel) || matchLabel : matchLabel;
    }
    /**
     * Gets the label for the final, starting from our i18n database and
     * calling `this.config.customFinalMatchLabel`, if that has been set.
     *
     * @param finalType Type of the final.
     * @param match Information about the match.
     */
    getFinalMatchLabel(finalType, match) {
        const { roundNumber, roundCount } = match.metadata;
        const matchLabel = lang.getFinalMatchLabel(finalType, roundNumber, roundCount);
        const customFinalMatchLabel = this.config.customFinalMatchLabel;
        return customFinalMatchLabel ? customFinalMatchLabel(finalType, match, lang.t, matchLabel) || matchLabel : matchLabel;
    }
    /**
     * Creates a hidden empty match to act as a placeholder.
     */
    skipBracketMatch() {
        const matchContainer = dom.createMatchContainer();
        const opponents = dom.createOpponentsContainer();
        const participant1 = this.createParticipant(null, true);
        const participant2 = this.createParticipant(null, true);
        opponents.append(participant1, participant2);
        matchContainer.append(opponents);
        matchContainer.style.visibility = 'hidden';
        return matchContainer;
    }
    /**
     * Creates a match based on its results.
     *
     * @param match Results of the match.
     * @param propagateHighlight Whether to highlight participants in other matches.
     */
    createMatch(match, propagateHighlight) {
        var _a, _b;
        const { match: matchStyles, opponents: opponentsStyles, participant1: participant1Styles, participant2: participant2Styles } = ((_b = (_a = this.config).getStyleForMatch) === null || _b === void 0 ? void 0 : _b.call(_a, match)) || {};
        const { classList: matchClassList, style: matchStyle } = matchStyles || {};
        const { classList: opponentsClassList, style: opponentsStyle } = opponentsStyles || {};
        const matchContainer = dom.createMatchContainer(match, matchClassList, matchStyle);
        const opponents = (0, helpers_1.isMatch)(match)
            ? dom.createOpponentsContainer(opponentsClassList, opponentsStyle, () => this._onMatchClick(match))
            : dom.createOpponentsContainer(opponentsClassList, opponentsStyle);
        if ((0, helpers_1.isMatch)(match) && match.status >= brackets_model_1.Status.Completed)
            match.metadata.originHint = undefined;
        if ((0, helpers_1.isMatch)(match)) {
            const { originHint, matchLocation, roundNumber } = match.metadata;
            const participant1 = this.createParticipant(match.opponent1, propagateHighlight, 'opponent1', originHint, matchLocation, roundNumber, participant1Styles);
            const participant2 = this.createParticipant(match.opponent2, propagateHighlight, 'opponent2', originHint, matchLocation, roundNumber, participant2Styles);
            this.renderMatchLabel(opponents, match);
            opponents.append(participant1, participant2);
        }
        else {
            const participant1 = this.createParticipant(match.opponent1, propagateHighlight, 'opponent1', undefined, undefined, undefined, participant1Styles);
            const participant2 = this.createParticipant(match.opponent2, propagateHighlight, 'opponent2', undefined, undefined, undefined, participant2Styles);
            this.renderMatchLabel(opponents, match);
            opponents.append(participant1, participant2);
        }
        matchContainer.append(opponents);
        if ((0, helpers_1.isMatch)(match)) {
            if (!match.metadata.connection)
                return matchContainer;
            dom.setupConnection(opponents, matchContainer, match.metadata.connection);
        }
        return matchContainer;
    }
    /**
     * Creates a participant for a match.
     *
     * @param participant Information about the participant.
     * @param propagateHighlight Whether to highlight the participant in other matches.
     * @param side Side of the participant.
     * @param originHint Origin hint for the match.
     * @param matchLocation Location of the match.
     * @param roundNumber Number of the round.
     * @param extraStyles Optional extra CSS classes and styles to add to the result.
     */
    createParticipant(participant, propagateHighlight, side, originHint, matchLocation, roundNumber, extraStyles) {
        const { classList, style } = extraStyles || {};
        const containers = {
            participant: dom.createParticipantContainer(participant && participant.id, classList, style),
            name: dom.createNameContainer(),
            result: dom.createResultContainer(),
        };
        if (participant === null || participant === undefined)
            dom.setupBye(containers.name);
        else
            this.renderParticipant(containers, participant, side, originHint, matchLocation, roundNumber);
        containers.participant.append(containers.name, containers.result);
        if (participant && participant.id !== null)
            this.setupMouseHover(participant.id, containers.participant, propagateHighlight);
        else if (participant === null || participant === undefined)
            this.setupPlaceholderMouseHover(containers.participant);
        return containers.participant;
    }
    /**
     * Renders a participant.
     *
     * @param containers Containers for the participant.
     * @param participant The participant result.
     * @param side Side of the participant.
     * @param originHint Origin hint for the match.
     * @param matchLocation Location of the match.
     * @param roundNumber Number of the round.
     */
    renderParticipant(containers, participant, side, originHint, matchLocation, roundNumber) {
        const found = this.participants.find(item => item.id === participant.id);
        if (found) {
            if (!this.config.noParticipantTitles)
                containers.participant.setAttribute('title', found.name);
            this.renderParticipantImage(containers.name, found.id);
            this.renderParticipantOrigin(containers.name, participant, side, matchLocation, roundNumber);
            const nameEl = document.createElement('span');
            nameEl.classList.add('innerName');
            nameEl.innerText = found.name;
            containers.name.appendChild(nameEl);
        }
        else
            this.renderHint(containers.name, participant, originHint, matchLocation);
        containers.result.innerText = `${participant.score === undefined ? '-' : participant.score}`;
        dom.setupWin(containers.participant, containers.result, participant);
        dom.setupLoss(containers.participant, containers.result, participant);
    }
    /**
     * Renders a participant image.
     *
     * @param nameContainer The name container.
     * @param participantId ID of the participant.
     */
    renderParticipantImage(nameContainer, participantId) {
        const found = this.participantImages.find(item => item.participantId === participantId);
        if (found)
            dom.addParticipantImage(nameContainer, found.imageUrl);
    }
    /**
     * Renders a match label.
     *
     * @param opponents The opponents container.
     * @param match Results of the match.
     */
    renderMatchLabel(opponents, match) {
        const { label } = match.metadata;
        if ((0, helpers_1.isMatchGame)(match)) {
            opponents.append(dom.createMatchLabel(label, lang.getMatchStatus(match.status)));
            return;
        }
        const onClick = (event) => {
            // Prevent `this._onMatchClick()` from being called.
            event.stopPropagation();
            this._onMatchLabelClick(match);
            if (match.child_count > 0 && this.config.showPopoverOnMatchLabelClick) {
                this.clearPreviousPopoverSelections();
                opponents.classList.add('popover-selected');
                this.showPopover(match);
            }
        };
        if (this.config.separatedChildCountLabel) {
            opponents.append(dom.createMatchLabel(label, lang.getMatchStatus(match.status), onClick));
            if (match.child_count > 0)
                opponents.append(dom.createChildCountLabel(lang.t('common.best-of-x', { x: match.child_count }), onClick));
            return;
        }
        if (match.child_count > 0) {
            const childCountLabel = lang.t('common.best-of-x', { x: match.child_count });
            const joined = label ? `${label}, ${childCountLabel}` : childCountLabel;
            opponents.append(dom.createMatchLabel(joined, lang.getMatchStatus(match.status), onClick));
        }
    }
    /**
     * Show a popover to display the games of a match.
     *
     * @param match The parent match.
     */
    showPopover(match) {
        this.popover.innerText = '';
        const matchLabel = this.getMatchLabel(match);
        const popoverTitle = dom.createPopoverTitle(matchLabel);
        this.popover.append(popoverTitle);
        for (const game of match.metadata.games) {
            const matchGameLabel = lang.t('match-label.match-game', { gameNumber: game.number });
            const match = this.createMatch({
                ...game,
                metadata: { label: matchGameLabel },
            }, false);
            this.popover.append(match);
        }
        try {
            this.popover.togglePopover();
        }
        catch {
            // Keep this while Firefox doesn't support the Popover API.
        }
    }
    /**
     * Renders an origin hint for a participant.
     *
     * @param nameContainer The name container.
     * @param participant The participant result.
     * @param originHint Origin hint for the participant.
     * @param matchLocation Location of the match.
     */
    renderHint(nameContainer, participant, originHint, matchLocation) {
        if (originHint === undefined || participant.position === undefined)
            return;
        if (!this.config.showSlotsOrigin)
            return;
        if (!this.config.showLowerBracketSlotsOrigin && matchLocation === 'loser_bracket')
            return;
        dom.setupHint(nameContainer, originHint(participant.position), this.config.noParticipantTitles);
    }
    /**
     * Renders a participant's origin.
     *
     * @param nameContainer The name container.
     * @param participant The participant result.
     * @param side Side of the participant.Side of the participant.
     * @param matchLocation Location of the match.
     * @param roundNumber Number of the round.
     */
    renderParticipantOrigin(nameContainer, participant, side, matchLocation, roundNumber) {
        if (participant.position === undefined || matchLocation === undefined)
            return;
        if (!this.config.participantOriginPlacement || this.config.participantOriginPlacement === 'none')
            return;
        if (!this.config.showSlotsOrigin)
            return;
        if (!this.config.showLowerBracketSlotsOrigin && matchLocation === 'loser_bracket')
            return;
        const abbreviation = (0, helpers_1.getOriginAbbreviation)(matchLocation, this.skipFirstRound, roundNumber, side);
        if (!abbreviation)
            return;
        const origin = `${abbreviation}${participant.position}`;
        dom.addParticipantOrigin(nameContainer, origin, this.config.participantOriginPlacement);
    }
    /**
     * Sets mouse hover events for a participant.
     *
     * @param participantId ID of the participant.
     * @param element The dom element to add events to.
     * @param propagateHighlight Whether to highlight the participant in other matches.
     */
    setupMouseHover(participantId, element, propagateHighlight) {
        if (!this.config.highlightParticipantOnHover)
            return;
        const setupListeners = (elements) => {
            this.addHoverListeners(element, elements);
        };
        if (!propagateHighlight) {
            setupListeners([element]);
            return;
        }
        const refs = this.participantRefs[participantId];
        if (!refs)
            throw Error(`The participant (id: ${participantId}) does not exist in the participants table.`);
        refs.push(element);
        setupListeners(refs);
    }
    /**
     * Sets mouse hover events for a placeholder (BYE or TBD).
     *
     * @param element The dom element to add events to.
     */
    setupPlaceholderMouseHover(element) {
        if (!this.config.highlightPlaceholdersOnHover)
            return;
        this.addHoverListeners(element, [element]);
    }
    /**
     * Add mouse hover events.
     *
     * @param targetEl The element that is being hovered over.
     * @param highlightableEls The elements that should be highlighted.
     */
    addHoverListeners(targetEl, highlightableEls) {
        targetEl.addEventListener('mouseenter', () => {
            highlightableEls.forEach(el => el.classList.add('hover'));
        });
        targetEl.addEventListener('mouseleave', () => {
            highlightableEls.forEach(el => el.classList.remove('hover'));
        });
    }
    /**
     * Clears any previous popover selections.
     */
    clearPreviousPopoverSelections() {
        var _a;
        (_a = document.querySelector('.opponents.popover-selected')) === null || _a === void 0 ? void 0 : _a.classList.remove('popover-selected');
    }
}
exports.BracketsViewer = BracketsViewer;
